import http from "@/apps/shared/baseService/config";

const base = {
  rota: "teacher",
  nome: "Professores"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_teachers: ({ commit, dispatch, getters }) => {
      if (localStorage.teachers) {
        commit("set_teachers", JSON.parse(localStorage.teachers));
      } else {
        dispatch("enableLoading");
      }
      service
        .listar(getters.get_teachers_filtros)
        .then(res => {
          localStorage.teachers = JSON.stringify(res.data);
          dispatch("disableLoading");
          commit("set_teachers", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_teacher: ({ commit, dispatch, getters }, payload) => {
      dispatch("enableLoading");
      let data = payload ? payload : getters.get_teacher;
      service
        .atualizar(data)
        .then(res => {
          dispatch("disableLoading");
          commit("set_teacher", res.data);
          if (payload.from_profile) {
            localStorage.setItem(
              "user",
              JSON.stringify({
                ...res.data,
                tenant: payload.tenant,
                permissao: payload.permissao
              })
            );
            commit("setLoggedUser", {
              ...res.data,
              tenant: payload.tenant,
              permissao: payload.permissao
            });
          }
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_teachers");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_teacher: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_teacher, imagens: getters.getLinks })
        .then(() => {
          dispatch("disableLoading");
          commit("set_teacher", {});
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_teachers");
          commit("set_modal_view_teacher", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_teacher: ({ dispatch }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_teachers");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_teacher: ({ commit }, payload) => {
      if (payload) {
        let data = payload;
        if (!data.professional_record) {
          data.professional_record = {
            advice: "",
            number: "",
            uf: ""
          };
        }
        if (!data.address) {  
          data.address = {
            street: "",
            number: "",
            complement: "",
            neighborhood: "",
            city: "",
            state: "",
            zipcode: ""
          };
        }
        commit("set_teacher", data);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_teacher", true);
    },
    fecha_modal_view_teacher: ({ commit }) => {
      commit("set_teacher", {});
      commit("setLinks", []);
      commit("set_modal_view_teacher", false);
    }
  },
  state: {
    teacher: {},
    teachers: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    teachers_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_teacher: false
  },
  mutations: {
    set_teacher: (state, payload) => (state.teacher = payload),
    set_teachers: (state, payload) => (state.teachers = payload),
    set_modal_view_teacher: (state, payload) =>
      (state.modal_view_teacher = payload)
  },
  getters: {
    get_teacher: state => state.teacher,
    get_teachers: state => state.teachers,
    get_modal_view_teacher: state => state.modal_view_teacher,
    get_teachers_filtros: state => state.teachers_filtros
  }
};

const routes = [
  {
    path: `/professores`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  },
  {
    path: `/inicio-professor`,
    component: () => import("./views/DashboardTeacher.vue"),
    name: base.nome
  },
  {
    path: `/inicio-admin`,
    component: () => import("./views/DashboardAdmin.vue"),
    name: base.nome
  },
];

export default {
  service,
  module,
  routes
};
